import React, { useState, useRef, useEffect } from "react";
import MessageBubble from "./MessageBubble";

const ChatInterface = () => {
	const [messages, setMessages] = useState([]);
	const [input, setInput] = useState("");
	const messagesEndRef = useRef(null);
	const messagesContainerRef = useRef(null);

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	useEffect(() => {
		scrollToBottom();
	}, [messages]);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!input.trim()) return;

		setMessages((prev) => [...prev, { text: input, sender: "user" }]);
		setInput("");
	};

	return (
		<div className="flex flex-col h-full overflow-hidden touch-none">
			<div
				ref={messagesContainerRef}
				className={`
          flex-1 overflow-y-auto p-4 space-y-4 
          mb-[4rem] sm:mb-[-1.5rem]
          overscroll-contain
          [&::-webkit-scrollbar]:w-2
          [&::-webkit-scrollbar-track]:bg-transparent
          [&::-webkit-scrollbar-thumb]:bg-transparent
          hover:[&::-webkit-scrollbar-thumb]:bg-gray-300
          dark:hover:[&::-webkit-scrollbar-thumb]:bg-gray-600
          [&::-webkit-scrollbar-thumb]:rounded-full
          ${messages.length === 0 ? "overflow-hidden" : ""}
        `}
			>
				{messages.map((message, index) => (
					<MessageBubble key={index} message={message} />
				))}
				<div ref={messagesEndRef} />
			</div>
			<div className="sm:p-4 sm:border-t sm:border-gray-200 sm:dark:border-gray-700 sm:relative fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 sm:bg-transparent sm:border-0 z-50">
				<form onSubmit={handleSubmit} className="p-4 pb-8 sm:p-0">
					<div className="flex space-x-2 max-w-7xl mx-auto">
						<input
							type="text"
							value={input}
							onChange={(e) => setInput(e.target.value)}
							placeholder="Ask about your schedule..."
							className="flex-1 p-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
						/>
						<button
							type="submit"
							className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
						>
							Send
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default ChatInterface;
